import { render, staticRenderFns } from "./ModifySaleStatus.vue?vue&type=template&id=06ccddb4&"
import script from "./ModifySaleStatus.vue?vue&type=script&lang=ts&"
export * from "./ModifySaleStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports